import { isNil, any } from 'ramda'

const keys = {
  accessToken: 'accessToken',
  maModeKey: 'maModeKey',
  refreshToken: 'refreshToken',
  expiresIn: 'expiresIn',
  expiresAt: 'expiresAt',
}

export const isValidToken = ({
  accessToken,
  refreshToken,
  expiresIn,
  expiresAt,
}) => !any(isNil, [accessToken, refreshToken, expiresIn, expiresAt])

export const saveToken = ({
  accessToken,
  refreshToken,
  expiresIn,
  expiresAt,
  maModeKey,
}) => {
  if (!isValidToken({ accessToken, refreshToken, expiresIn, expiresAt })) return
  localStorage.setItem(keys.accessToken, accessToken)
  localStorage.setItem(keys.refreshToken, refreshToken)
  localStorage.setItem(keys.expiresIn, expiresIn)
  localStorage.setItem(keys.expiresAt, expiresAt)
  if (isNil(maModeKey)) {
    localStorage.removeItem(keys.maModeKey)
  } else {
    localStorage.setItem(keys.maModeKey, maModeKey)
  }
}

export const updateAccessToken = ({
  accessToken,
  expiresIn,
  expiresAt,
  maModeKey,
}) => {
  if (any(isNil, [accessToken, expiresIn, expiresAt])) return

  localStorage.setItem(keys.accessToken, accessToken)
  localStorage.setItem(keys.expiresIn, expiresIn)
  localStorage.setItem(keys.expiresAt, expiresAt)
  if (isNil(maModeKey)) {
    localStorage.removeItem(keys.maModeKey)
  } else {
    localStorage.setItem(keys.maModeKey, maModeKey)
  }
}

export const updateMaModeKey = (maModeKey) => {
  if (isNil(maModeKey)) {
    localStorage.removeItem(keys.maModeKey)
  } else {
    localStorage.setItem(keys.maModeKey, maModeKey)
  }
}

export const getToken = () => {
  const accessToken = localStorage.getItem(keys.accessToken)
  const refreshToken = localStorage.getItem(keys.refreshToken)
  const expiresIn = localStorage.getItem(keys.expiresIn)
  const expiresAt = localStorage.getItem(keys.expiresAt)
  const maModeKey = localStorage.getItem(keys.maModeKey)
  let token = {
    accessToken,
    refreshToken,
    expiresIn,
    expiresAt,
  }

  if (!isNil(maModeKey)) {
    token = { ...token, maModeKey }
  }

  return !isValidToken({ accessToken, refreshToken, expiresIn, expiresAt })
    ? !isNil(maModeKey)
      ? maModeKey
      : undefined
    : token
}

export const removeToken = () => {
  localStorage.removeItem(keys.accessToken)
  localStorage.removeItem(keys.refreshToken)
  localStorage.removeItem(keys.expiresIn)
  localStorage.removeItem(keys.expiresAt)
}

export const isTokenExists = () => getToken() !== undefined
